<button mat-button type="button" (click)="clicked($event)" [color]="color" [class.active]="active" [class.mat-raised-button]="raised" [disabled]="active || disabled" class="fullWidth">
    <ng-content></ng-content>
    <span [class.active]="active">{{ text }}</span>
    <mat-progress-spinner class="spinner" *ngIf="active" [diameter]="diameter" [color]="color" class="bar" [mode]="mode" [value]="value">
    </mat-progress-spinner>
</button>
